import { render, staticRenderFns } from "./dashboard-view.vue?vue&type=template&id=3c9ca89b&scoped=true&"
import script from "./dashboard-view.vue?vue&type=script&lang=js&"
export * from "./dashboard-view.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-view.vue?vue&type=style&index=0&id=3c9ca89b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9ca89b",
  null
  
)

export default component.exports